import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";

export default class CreateOrderResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: {
                "number": 1,
                "state": "INITIAL",
                "customer": {
                    "code": 5,
                    "business_name": 2,
                    "number": 2,
                    "fantasy_name": "Customer",
                    "delivery_sites": [{
                        "name": "Customer Delivery Site",
                        "address": "Address",
                        "city": "City",
                    }],
                },
                "delivery_site": {
                    "name": "Customer Delivery Site",
                    "address": "Address",
                    "city": "City",
                },
                "delivery_date": "20-05-2024",
                "observations": "An Observation"
            },
            errors: []
        }
    }

    order() {
        return {
            number: this.number(),
            state: this.state(),
            customer: this.customer(),
            deliverySite: this.deliverySite(),
            deliveryDate: this.deliveryDate(),
            observations: this.observations()
        }
    }

    number() {
        return this.content().number;
    }

    state() {
        return this.content().state;
    }

    customer() {
        const customer = this.content().customer
        return {
            code: customer.code,
            businessName: customer.business_name,
            customerCode: customer.code,
            fantasyName: customer.fantasy_name,
        }
    }

    deliverySite() {
        const deliverySite = this.content().delivery_site
        return {
            deliverySiteName: deliverySite.name,
            deliverySiteAddress: deliverySite.location.address,
            deliverySiteCity: deliverySite.location.city,
            deliveryDate: "",
        }
    }

    deliveryDate() {
        return this.content().delivery_date
    }

    observations() {
        return this.content().observations
    }
}